import React, { useState } from 'react';
import { ChevronDown, ChevronUp, CheckCircle2, Sparkles } from 'lucide-react';
interface Tomo {
  icon: string;
  title: string;
  desc: string;
}
export function ProductShowcase() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const tomos: Tomo[] = [{
    icon: '📘',
    title: 'Diseño de Corrales Rectos',
    desc: 'Configuraciones prácticas y funcionales para facilitar el trabajo diario.'
  }, {
    icon: '📘',
    title: 'Corrales Curvos y Circulación Inteligente',
    desc: 'Diseños pensados para mejorar el flujo natural del ganado y reducir estrés.'
  }, {
    icon: '📘',
    title: 'Sistemas de Encierre',
    desc: 'Opciones eficientes para manejo seguro y organización del trabajo rural.'
  }, {
    icon: '📘',
    title: 'Apartaderos y Distribución Funcional',
    desc: 'Configuraciones prácticas para clasificación y circulación eficiente.'
  }, {
    icon: '📘',
    title: 'Corrales con Manga',
    desc: 'Diseños modernos para vacunación, manejo y trabajo práctico.'
  }, {
    icon: '📘',
    title: 'Embarcaderos y Zonas de Trabajo',
    desc: 'Sistemas funcionales para facilitar carga y descarga de animales.'
  }];
  return <section className="py-10 md:py-14 px-4 bg-zinc-950" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        {/* Intro */}
        <div className="text-center mb-8 md:mb-10" data-id="element-161">
          <div className="inline-flex items-center gap-1.5 bg-brand-green text-white font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md" data-id="element-162">
            <Sparkles className="w-3.5 h-3.5" data-id="element-163" /> Presentamos
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-[1.05] mb-3" data-id="element-164">
            Sistema Pro <br className="md:hidden" data-id="element-165" />
            <span className="text-brand-greenLight" data-id="element-166">Corrales Ganaderos™</span>
          </h2>
          <p className="text-sm md:text-lg font-display font-bold text-zinc-300 max-w-2xl mx-auto" data-id="element-167">
            75 Diseños Profesionales para{' '}
            <span className="highlight-green" data-id="element-168">Optimizar el Manejo</span> y la
            Productividad
          </p>
        </div>

        {/* Value props */}
        <div className="bg-zinc-900 border border-brand-green/40 rounded-xl p-5 md:p-6 mb-8 shadow-xl" data-id="element-169">
          <p className="text-sm md:text-base text-white font-bold mb-3 text-center" data-id="element-170">
            Un sistema pensado para productores que quieren:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-171">
            {['trabajar más cómodos', 'ahorrar tiempo', 'mejorar el manejo', 'reducir estrés animal', 'construir instalaciones más eficientes'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-172">
                <CheckCircle2 className="w-4 h-4 text-brand-greenLight shrink-0" data-id="element-173" />
                <span className="text-xs md:text-sm text-zinc-200 font-semibold" data-id="element-174">
                  {item}
                </span>
              </div>)}
          </div>
          <blockquote className="mt-4 pt-4 border-t border-brand-green/30 text-center italic text-zinc-300 text-xs md:text-sm" data-id="element-175">
            "Un sistema creado para productores que quieren trabajar mejor todos
            los días."
          </blockquote>
        </div>

        {/* Tomos section */}
        <h3 className="text-xl md:text-3xl font-display font-bold text-center text-white uppercase mb-2" data-id="element-176">
          Mirá todo lo que incluye el sistema
        </h3>
        <p className="text-center text-zinc-400 mb-6 text-xs md:text-sm" data-id="element-177">
          👇 Tocá cada tomo para ver el detalle
        </p>

        <div className="space-y-2.5" data-id="element-178">
          {tomos.map((tomo, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-zinc-900 rounded-lg border-2 overflow-hidden transition-all duration-200 ${isOpen ? 'border-brand-green shadow-lg glow-green' : 'border-brand-green/20 hover:border-brand-green/60'}`} data-id="element-179">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-3.5 py-3 md:px-5 md:py-4 text-left flex items-center justify-between gap-2.5 focus:outline-none" data-id="element-180">
                  <div className="flex items-center gap-2.5 md:gap-3 flex-1" data-id="element-181">
                    <span className="text-xl md:text-2xl shrink-0" data-id="element-182">
                      {tomo.icon}
                    </span>
                    <h4 className="font-display font-bold text-sm md:text-lg text-white uppercase leading-tight" data-id="element-183">
                      {tomo.title}
                    </h4>
                  </div>
                  <div className={`shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-green text-white' : 'bg-zinc-800 text-brand-greenLight'}`} data-id="element-184">
                    {isOpen ? <ChevronUp className="w-4 h-4" data-id="element-185" /> : <ChevronDown className="w-4 h-4" data-id="element-186" />}
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40' : 'max-h-0'}`} data-id="element-187">
                  <div className="px-3.5 pb-4 md:px-5 md:pb-5 pl-[56px] md:pl-[72px]" data-id="element-188">
                    <div className="border-t border-brand-green/30 pt-3" data-id="element-189">
                      <p className="text-xs md:text-sm text-zinc-300 leading-relaxed" data-id="element-190">
                        {tomo.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}